<template>
  <div id="login">
    <div class="form-disabled" v-if="formDisabled"></div>
    <div id="login-panel">
      <div class="instruction">Sign in using your Microsoft Account</div>
      <span><a-button @click="signIn" id="login-button">Log in</a-button></span>
      <div class="error" v-if="isSignedInFailed && signInError">{{signInError}}</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "Login",
    data() {
      return {
        formDisabled: false
      }
    },
    computed: {
      ...mapGetters('auth', [
        'isSignedInFailed','signInError'
      ]),
    },
    methods: {
      ...mapActions("auth", ["signInPopup"]),
      signIn() {
        console.log("Sign in!");
        this.formDisabled = true;
        this.signInPopup()
          .then(response => {
            // proceed to main page
            this.$router.push("/batch-history");
          })
          .catch(error => {
            // user either failed the login or closed the microsoft login page
            console.log("Sign-in cancelled:", error);
            this.formDisabled = false;
          });
      }
    }
  }
</script>

<style scoped lang="scss">

  #login-panel {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    max-width: 100vw;
    max-height: 100vw;

    padding: 35px 40px;
    text-align: center;
    min-width: 460px;
    min-height: 280px;

    border-radius: 6px;
    -webkit-box-shadow: 1px 1px 4px 0 rgba(0,0,0,.15);
    box-shadow: 1px 1px 4px 0 rgba(0,0,0,.15);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .form-disabled {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.6);
    z-index: 1000;
  }

  .instruction {
    margin-bottom: 34px;
    font-size: 18px;
    /*font-weight: 500;*/
    color: #152939;
  }

  .error {
    color: #f53d3d;
  }

  #login-button {
    background: #f90;
    color: #fff;

    min-width: 153px;
    min-height: 50px;
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;

    text-transform: uppercase;
    letter-spacing: 1.1px;
    border: none;
    border-radius: unset;
    margin-bottom: 34px;

    &:hover {
      opacity: .7;
    }
  }


</style>